<template>
  <div class="page-comp-product-price-info">
    <special-head title="价格信息">
      <template #extra>
        <jw-button v-permission="['product:addPrice']" v-if="buttons.indexOf('product:addPrice') > -1" type="text" size="small" @click="addEdit(0)" class="price-info-add-btn"><qfei-icon-add-two-outlined />{{ $t('新建') }}</jw-button>
      </template>
    </special-head>
    <special-table :checkedParams="{ width: 38 }" :columns="columns" :data="dataList" :pagination="pagination" @paginationEvent="onPaginationEvent" :loading="loading">
      <template #price="{ row }">
        <span>{{ row?.price?.toFixed(2) || '-' }}</span>
      </template>
      <template #periodTime="{ row }">
        <span>{{ row?.startTime && row?.endTime ? dayjs(row?.startTime).format('YYYY-MM-DD') + '/' + dayjs(row?.endTime).format('YYYY-MM-DD') : '-' }}</span>
      </template>
      <template #operations="{ row }">
        <jw-space>
          <jw-link type="text" @click="addEdit(1, row)" v-permission="['product:editPrice']" v-if="buttons.indexOf('product:editPrice') > -1">{{ $t('编辑') }}</jw-link>
          <jw-link type="text" @click="deleteProduct(row.id)" v-permission="['product:delPrice']" v-if="buttons.indexOf('product:delPrice') > -1">{{ $t('删除') }}</jw-link>
        </jw-space>
      </template>
    </special-table>

    <product-price-update ref="priceUpdateRef" @cb="getPriceList"></product-price-update>
  </div>
</template>

<script>
import { inject, onMounted, reactive, toRefs, ref } from 'vue';
import { Message, Modal } from '@arco-design/web-vue';
import { productService, layoutService } from '@/api/';
import dayjs from 'dayjs';
import ProductPriceUpdate from '../product-price-update/index.vue';
import SpecialTable from '@/components/fh-detail/components/special-table/index.vue';
import SpecialHead from '@/components/fh-detail/components/special-head/index.vue';
import { useUserStore } from '@/store';
import { tools } from '@/utils/tools.js';
import { useI18n } from 'vue-i18n';
import useFhSpecialTable from '@/hooks/fh-special-table';
export default {
  name: 'ProductPriceInfo',
  components: {
    ProductPriceUpdate,
    SpecialTable,
    SpecialHead
  },
  props: {
    moduleId: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { t } = useI18n();

    //
    const data = reactive({
      type: 0,
      productId: inject('globalParams')?.id || inject('detailParams')?.id,
      entity: inject('globalParams')?.entity || inject('detailParams')?.entity,
      loading: false
    });
    const { userInfo } = useUserStore;
    const priceUpdateRef = ref();

    const cb = (data) => {
      console.log(64, data);
      data.forEach((i) => (i.price = tools.getPrice(i.price)));
      return data;
    };

    const { pagination, onPaginationEvent, getDataList, dataList } = useFhSpecialTable({ productId: data.productId }, productService.getProductPrice.bind(productService), cb);

    const columns = [
      {
        title: '产品价格',
        colKey: 'price',
        slotName: 'price',
        width: 150
      },
      {
        title: '币种',
        colKey: 'currencyValue',
        width: 90
      },
      {
        title: '时长单位',
        colKey: 'timeTypeValue',
        width: 100
      },
      {
        title: '规格单位',
        colKey: 'unitValue',
        width: 100
      },
      {
        title: '有效期',
        dataIndex: 'periodTime',
        slotName: 'periodTime',
        width: 250
      },
      {
        title: '操作',
        colKey: 'operations',
        slotName: 'operations',
        width: 140
      }
    ];
    // 新增和编辑
    const addEdit = (type, record) => {
      // type:0新增价格，1编辑价格
      data.type = type;
      const params = {
        type: type,
        title: t('新增价格'),
        record: record
      };
      if (type === 0) {
        console.log('处理新增');
        priceUpdateRef.value.open(params);
      } else {
        console.log('处理编辑', record);
        params.title = t('编辑价格');
        priceUpdateRef.value.open(params);
      }
    };
    //删除产品deletePrice
    const deleteProduct = (id) => {
      Modal.confirm({
        titleAlign: 'start',
        width: 400,
        simple: false,
        title: t('tips.sweet'),
        content: t('tips.remove'),
        okText: t('确定'),
        cancelText: t('取消'),
        onOk: () => {
          deletePrice({ productIds: [id] });
          console.log('删除id', id);
        }
      });
    };
    const deletePrice = async (params) => {
      try {
        const json = await productService.deletePrice(params);
        if (!json.error) {
          Message.success(t('操作成功'));
          getPriceList();
        } else {
          Message.error(json.error?.msg || t('操作失败'));
        }
      } catch (e) {
        console.log(e);
        Message.error(e.message || e.statusText || t('操作失败'));
      }
    };
    const getPriceList = () => {
      getDataList();
    };

    onMounted(() => {
      getPriceList();
      getDetail();
    });
    const buttons = ref([]);
    const getDetail = async () => {
      if (!props?.moduleId) {
        return false;
      }
      try {
        const params = {
          entity: data.entity,
          moduleId: props.moduleId,
          businessId: data.productId
        };
        const json = await layoutService.getDetail(params);
        if (!json.error) {
          const _buttons = [];
          json?.result?.map((b) => {
            _buttons.push(b.value);
          });
          buttons.value = _buttons;
        }
      } catch (e) {
        console.log(e);
      }
    };
    return {
      columns,
      getPriceList,
      priceUpdateRef,
      dayjs,
      addEdit,
      userInfo,
      buttons,
      deleteProduct,
      pagination,
      dataList,
      onPaginationEvent,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
